import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";

import useStripeConnect from "../../../hooks/useStripeConnect";

const CompleteOnboard = () => {
  const { accountType, accountId, id } = useParams();

  const { stripeConnectInstance, instanceLoading } = useStripeConnect(
    accountId || ""
  );

  const [onboardingExited, setOnboardingExited] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const onLoadError = (loadError) => {
    const componentName = loadError.elementTagName;
    const error = loadError.error;
    console.log(componentName + " failed to load");
    console.log(`${error.type}: ${error.message}`);
  };

  const onLoaderStart = (event) => {
    setLoading(false);
  };

  const onExit = async (event) => {
    console.log("event: ", event);
    setOnboardingExited(true);
    history.push(`/view-account/bank-account/${accountId}/${id}`);
  };

  return (
    <div>
      <Helmet>
        <title>eksplode! | Payment Integration</title>
      </Helmet>
      <Breadcrumb title={"Add Account"} />

      <section className="about-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="box-head">
                <div className="d-flex justify-content-between">
                  <h2 className="text-dark">Complete The On-boarding</h2>
                </div>
              </div>
            </div>

            <div className="col-12 mb-3">
              {instanceLoading ? (
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                  Creating Account Session....
                </div>
              ) : (
                <ConnectComponentsProvider
                  connectInstance={stripeConnectInstance}
                >
                  {loading && "Loading"}
                  <ConnectAccountOnboarding
                    onExit={onExit}
                    onLoadError={onLoadError}
                    onLoaderStart={onLoaderStart}
                    collectionOptions={{
                      fields: "eventually_due",
                      futureRequirements: "include",
                    }}
                    onStepChange={(stepChange) => {
                      console.log(`User entered: ${stepChange.step}`);
                    }}
                  />
                </ConnectComponentsProvider>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompleteOnboard;
